import React from 'react';
import { Dropdown } from 'semantic-ui-react';

import { labelByKey } from '@cm/new-shared-fe/services/labels';

export const OTHER_OPTION = 'other';

export class MultiSelectDropdown extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      placeholder: labelByKey('name.field.placeholder'),
    };

    this.handleChange = this.handleChange.bind(this);
  }

  render () {
    const options = this.props.familyMembers.map(familyMember => ({
      text: `${familyMember.firstName} ${familyMember.name}`,
      value: familyMember.nrn,
    }));
    options.push({
      text: labelByKey('name.field.other.option'),
      value: OTHER_OPTION,
    });

    return (
      <div className="form-multiple" data-e2e="member-multi-select">
        <label
          className="font-bold text-md inline-block py-1.5"
          htmlFor="family-member"
        >
          {labelByKey('name.field.label')}
        </label>
        <Dropdown
          placeholder={this.state.placeholder}
          fluid multiple selection clearable
          ref={this.props.multiRef}
          options={options}
          onChange={this.handleChange}
        />
      </div>
    );
  }

  handleChange (e, { value }) {
    // https://reactjs.org/docs/lifting-state-up.html
    this.props.onValuesChange(value);
  }
}
